import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../../shadcn/components/ui/Tabs';
import { ViewOutOfBoxAvailability } from './viewOutOfBoxAvailability';
import { OutOfBoxAvailabilityUpload } from './outOfBoxAvailabilityUpload';

const TabValues = Object.freeze({
    VIEW_DATA: 'view-data',
    BULK_UPLOAD: 'bulk-upload',
});

function OutOfBoxAvailability() {
    const [selectedTab, setSelectedTab] = useState(TabValues.VIEW_DATA);

    return (
        <div className="w-full p-6">
            <div className="mb-6">
                <h1 className="text-3xl font-bold text-gray-900">Out of Box Availability</h1>
                <p className="text-gray-600 mt-2">Manage and upload out of box availability data</p>
            </div>

            <Tabs value={selectedTab} onValueChange={setSelectedTab} className="w-full">
                <TabsList className="grid w-full grid-cols-2">
                    <TabsTrigger value={TabValues.VIEW_DATA}>View Data</TabsTrigger>
                    <TabsTrigger value={TabValues.BULK_UPLOAD}>Bulk Upload</TabsTrigger>
                </TabsList>
                
                <TabsContent value={TabValues.VIEW_DATA} className="mt-6">
                    <ViewOutOfBoxAvailability />
                </TabsContent>
                
                <TabsContent value={TabValues.BULK_UPLOAD} className="mt-6">
                    <OutOfBoxAvailabilityUpload />
                </TabsContent>
            </Tabs>
        </div>
    );
}

export { OutOfBoxAvailability }; 